import { iRoom } from '@ui-components/models';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, finalize, map, take, tap } from 'rxjs/operators';
import { EStatus } from '@ui-components/models';
 

@Injectable({
  providedIn: 'root'
})
export class ConfRoomsService {

  private conferenceRoomsSubject = new BehaviorSubject<iRoom[]>(null);
  conferenceRooms$: Observable<iRoom[]> = this.conferenceRoomsSubject.asObservable();

  private loaderSubject = new BehaviorSubject<boolean>(false);
  showLoader$: Observable<boolean> = this.loaderSubject.asObservable();

  constructor(private http: HttpClient) {
    this.getRooms().subscribe()
  }

  getRooms(): Observable<iRoom[]> {
    // 1 is culture Id for now
    return this.http.get<iRoom[]>('/Locations/GetLocations/1')
      .pipe(
        tap((rooms) => rooms && this.conferenceRoomsSubject.next(rooms)),
        catchError((err) => of([]))
      )
  }

  // helper methods
  getConferenceRoomById(id: number) {
    if (!id) { return; }

    let rooms;
    this.conferenceRooms$.pipe(take(1)).subscribe(res => rooms = res);
    return rooms.find((r: iRoom) => r.id === +id);
  }


}
